export default "__VITE_ASSET__DopXe5si__"